import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '@/hooks/useAuth'

export default function WelcomeSection() {
  const { t } = useTranslation('home')
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!user) {
      logout()
      navigate('/login')
    }
  }, [user, logout, navigate])

  const username = user?.name || t('welcome.defaultUser', 'User')

  return (
    <div className="mb-12 text-center">
      <h1 className="text-4xl font-bold text-text-dark mb-6">
        {t('welcome.title', { username })}
      </h1>
      <p className="text-xl text-gray-600 max-w-3xl mx-auto">
        {t('welcome.description')}
      </p>
    </div>
  )
}
